import { useFetch } from "@/helpers/useFetch.js";

const { request } = useFetch();

export const getSidebar = () => request("GET", "/sidebar");
